import useSWRMutation from "swr/mutation";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { EnrolledUserItem } from "../types";

import { RefreshCertificatesResult } from "@utils/refreshCertificatesOutcome";

interface RefreshAllCertificatesArgs {
  corporateId: string | number;
  objectId: number;
}

export interface RefreshUserCertificatesArgs extends RefreshAllCertificatesArgs {
  learnerId: string | number;
  issuedCertificateIds: number[];
}

export type {
  RefreshSkipReason,
  RefreshCertificatesResult,
  RefreshOutcomeKind,
  RefreshOutcome,
  RefreshResultLine,
} from "@utils/refreshCertificatesOutcome";
export {
  getRefreshOutcome,
  getRefreshResultLines,
} from "@utils/refreshCertificatesOutcome";

export const getIssuedCertificateIds = (user: EnrolledUserItem): number[] =>
  user.certificateIds ?? [];

export const useRefreshCertificates = () => {
  const { trigger: refreshAll, isMutating: isRefreshingAll } = useSWRMutation(
    ServicesURL.refreshIssuedCertificatePlaceholdersMassive,
    (
      url: string,
      { arg }: { arg: RefreshAllCertificatesArgs },
    ): Promise<RefreshCertificatesResult> =>
      fetcher<any>(url, MethodType.POST, {
        corporateId: Number(arg.corporateId),
        objectId: Number(arg.objectId),
      }),
    { onError: () => {} },
  );

  const { trigger: refreshUser, isMutating: isRefreshingUser } = useSWRMutation(
    ServicesURL.refreshIssuedCertificatePlaceholders,
    (
      url: string,
      { arg }: { arg: RefreshUserCertificatesArgs },
    ): Promise<RefreshCertificatesResult> =>
      fetcher<any>(url, MethodType.POST, {
        corporateId: Number(arg.corporateId),
        objectId: Number(arg.objectId),
        learnerId: Number(arg.learnerId),
        issuedCertificateIds: arg.issuedCertificateIds,
      }),
    { onError: () => {} },
  );

  return {
    refreshAll,
    refreshUser,
    isMutating: isRefreshingAll || isRefreshingUser,
  };
};
